// 外卖
const state = () => ({
  curShop: {}
})

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  setCurShop: function(state, data) {
    state.curShop = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/takeout.js